
import MDButton from "components/MDButton";
import { useState } from "react";
import { Box } from "@mui/material";
import MDInput from "components/MDInput";
import {
    Send_Message
} from "context";
import MDBox from "components/MDBox";
import { Message } from "@mui/icons-material";
import PropTypes from "prop-types";



const MessageForm = ({ selectedChatID }) => {
    const [message, setMessage] = useState("");
    const handleMessageSend = async () => {
        if (!message.trim() || !selectedChatID) return; // Prevent sending empty messages or when no chat is selected
        const body = { message, chat_id: selectedChatID, is_client: false };
        await Send_Message(body);
        setMessage(""); // Clear input after sending
    };

    return (
        <MDBox sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <MDInput
                fullWidth
                placeholder="Type a message"
                size="large"
                label="Type Message"
                multiline
                rows={1}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                disabled={!selectedChatID} // Disable input if no chat is selected
            />
            <MDButton 
                variant="contained" 
                onClick={handleMessageSend} 
                color="info"
                disabled={!selectedChatID || !message.trim()} // Disable button if no chat is selected or message is empty
            >
                Send
            </MDButton>
        </MDBox>
    );
};

MessageForm.propTypes = {
    selectedChatID: PropTypes.string, // Expecting a single chat ID as a string
};

export default MessageForm;